"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "keysToCamelCase", {
  enumerable: true,
  get: function () {
    return _keysToCamelCase.default;
  }
});
Object.defineProperty(exports, "keysToCamelCaseDeep", {
  enumerable: true,
  get: function () {
    return _keysToCamelCaseDeep.default;
  }
});
Object.defineProperty(exports, "SessionStorage", {
  enumerable: true,
  get: function () {
    return _sessionStorage.default;
  }
});
Object.defineProperty(exports, "LocalStorage", {
  enumerable: true,
  get: function () {
    return _localStorage.default;
  }
});
Object.defineProperty(exports, "keysToSnakeCase", {
  enumerable: true,
  get: function () {
    return _keysToSnakeCase.default;
  }
});
Object.defineProperty(exports, "keysToSnakeCaseDeep", {
  enumerable: true,
  get: function () {
    return _keysToSnakeCaseDeep.default;
  }
});
Object.defineProperty(exports, "mapDeep", {
  enumerable: true,
  get: function () {
    return _mapDeep.default;
  }
});
Object.defineProperty(exports, "isMobile", {
  enumerable: true,
  get: function () {
    return _isMobile.default;
  }
});
Object.defineProperty(exports, "getScreenSizeClassification", {
  enumerable: true,
  get: function () {
    return _getScreenSizeClassification.default;
  }
});
Object.defineProperty(exports, "screenClassificationsType", {
  enumerable: true,
  get: function () {
    return _getScreenSizeClassification.screenClassificationsType;
  }
});
Object.defineProperty(exports, "getDeviceTypeByScreen", {
  enumerable: true,
  get: function () {
    return _getDeviceTypeByScreen.default;
  }
});
Object.defineProperty(exports, "devicesTypes", {
  enumerable: true,
  get: function () {
    return _getDeviceTypeByScreen.devicesTypes;
  }
});

var _keysToCamelCase = _interopRequireDefault(require("./keys-to-camel-case"));

var _keysToCamelCaseDeep = _interopRequireDefault(require("./keys-to-camel-case-deep"));

var _sessionStorage = _interopRequireDefault(require("./session-storage"));

var _localStorage = _interopRequireDefault(require("./local-storage"));

var _keysToSnakeCase = _interopRequireDefault(require("./keys-to-snake-case"));

var _keysToSnakeCaseDeep = _interopRequireDefault(require("./keys-to-snake-case-deep"));

var _mapDeep = _interopRequireDefault(require("./map-deep"));

var _isMobile = _interopRequireDefault(require("./is-mobile"));

var _getScreenSizeClassification = _interopRequireWildcard(require("./get-screen-size-classification"));

var _getDeviceTypeByScreen = _interopRequireWildcard(require("./get-device-type-by-screen"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }